import React from 'react'
import PropTypes from 'prop-types'
import { Box, Image } from '@chakra-ui/react'
import { pxToRem } from '../../utills/pxToRem'

const CloudinaryImageSwatches = ({
    cloudinaryImageGallery = {},
    value,
    onChange
}) => {
    if (!cloudinaryImageGallery.cldSwatches) return null;

    return (
        <>
            {cloudinaryImageGallery.cldSwatches.map((cldSwatch, idx) => {
                const { variationAttrValueID, cldUrl } = cldSwatch;
                const isSelected = value === variationAttrValueID;

                return (
                    <Box
                        as="button"
                        key={variationAttrValueID || idx}
                        onClick={() => onChange && onChange(variationAttrValueID)}
                        border={isSelected ? `${pxToRem(1)} solid black` : `${pxToRem(1)} solid transparent`}
                        borderRadius="full"
                        p={
                            isSelected
                                ? [pxToRem(2), pxToRem(2), pxToRem(5), pxToRem(5)]
                                : pxToRem(1)
                        }
                        bg="transparent"
                        cursor="pointer"
                        width={[pxToRem(25), pxToRem(25), pxToRem(36), pxToRem(36)]}
                        height={[pxToRem(25), pxToRem(25), pxToRem(36), pxToRem(36)]}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        transition="border 0.2s, padding 0.2s"
                    >
                        <Image
                            width={[pxToRem(18), pxToRem(18), pxToRem(30), pxToRem(30)]}
                            height={[pxToRem(18), pxToRem(18), pxToRem(30), pxToRem(30)]}
                            borderRadius="full"
                            src={cldUrl}
                            alt={variationAttrValueID}
                        />
                    </Box>
                );
            })}
        </>
    );
}

CloudinaryImageSwatches.propTypes = {
    cloudinaryImageGallery: PropTypes.object,
    value: PropTypes.string,
    onChange: PropTypes.func
}

export default CloudinaryImageSwatches
